import { render, staticRenderFns } from "./TakeActions.vue?vue&type=template&id=6d3e6a4d&scoped=true"
import script from "./TakeActions.vue?vue&type=script&lang=js"
export * from "./TakeActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3e6a4d",
  null
  
)

export default component.exports